document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper('.images-sliders', {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach(()=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                }
            });
            let linkSwiper = document.querySelectorAll(".swiper-pagination-bullet");
            linkSwiper.forEach((nav)=>{
                nav.addEventListener("mouseover",()=>{
                    nav.click();
                });
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let mapSlider = document.querySelectorAll('.map-slider');
    if(mapSlider){
        mapSlider.forEach(()=>{
            new Swiper('.map-slider', {
                effect: "fade",
                speed: 1000,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                }
            });
        });
    }

    let carouselDrag = document.querySelectorAll('.carousel-drag-slider');
    if(carouselDrag){
        carouselDrag.forEach(()=> {
            new Swiper('.carousel-drag-slider', {
                loop: true,
                slidesPerView: 1,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    769: {
                        slidesPerView: "auto",
                    },
                    600: {
                        slidesPerView: 2,
                    }
                }
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper('.slider-slide', {
                loop: true,
                effect: "fade",
                uniqueNavElements:false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        autoHeight: false,
                    }
                }
            });
        });
    }

    let carouselSlider = document.querySelectorAll('.carousel-slider');
    if(carouselSlider){
        carouselSlider.forEach((item)=> {
            new Swiper('.carousel-slider', {
                loop: true,
                rewind: false,
                slidesPerView: 1,
                slidesPerGroup: 1,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    769: {
                        slidesPerView: 3,
                        slidesPerGroup: 2,
                        loop: false,
                        rewind: true,
                    },
                    600: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        loop: false,
                        rewind: true,
                    }
                }
            });
        });
    }

    let tapsTap = document.querySelectorAll('.accordion-maps');
    let mapsGaSlider = document.querySelectorAll('.maps-ga-slider');
    if(mapsGaSlider){
        const mapsGaSlider = new Swiper('.maps-ga-slider', {
            rewind: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        tapsTap.forEach(function(tB,tBc) {
            let tNav = tB.querySelectorAll('.tab-label');
            tNav.forEach(function(t_nav) {
                let navCount = t_nav.dataset.nav;
                t_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(tapsTap.length > 1){
                        mapsGaSlider[tBc].slideTo(navCount, 1000);
                    } else {
                        mapsGaSlider.slideTo(navCount, 1000);
                    }
                    tNav.forEach(function(t_nav) {
                        t_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(tapsTap.length > 1){
                    mapsGaSlider[tBc].on('slideChange', function () {
                        tNav.forEach(function(t_nav) {
                            let navC = t_nav.dataset.nav;
                            t_nav.classList.remove('active');
                            if(mapsGaSlider[tBc].realIndex == navC){
                                t_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    mapsGaSlider.on('slideChange', function () {
                        tNav.forEach(function(t_nav) {
                            let navC = t_nav.dataset.nav;
                            t_nav.classList.remove('active');
                            if(mapsGaSlider.realIndex == navC){
                                t_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let timelineSlider = document.querySelectorAll('.timeline-slider');
    if(timelineSlider){
        timelineSlider.forEach(()=> {
            let timeline_slider_name = new Swiper('.timeline-slider-name', {
                rewind: true,
                slidesPerView: 2,
                freeMode: true,
                watchSlidesProgress: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    770: {
                        slidesPerView: 6,
                    },
                    600: {
                        slidesPerView: 4,
                    }
                }
            });
            new Swiper('.timeline-slider', {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                thumbs: {
                    swiper: timeline_slider_name,
                },
            });
        });
    }

});